import { render } from "./connectionsComponent.vue?vue&type=template&id=de6dd154"
import script from "./connectionsComponent.vue?vue&type=script&lang=js"
export * from "./connectionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__